import GraphUsersTypeAhead from './GraphUsersTypeAhead';

export default GraphUsersTypeAhead;
